import { UserRequest } from '../user-request';

export class UserAffiliationDetailRequest extends UserRequest {
  public suspenseId: number;
}
